import React from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

export const AFFINITY_POLICIES = {
  HARD_AFFINITY: 'affinity',
  HARD_ANTI_AFFINITY: 'anti-affinity',
  SOFT_AFFINITY: 'soft-affinity',
  SOFT_ANTI_AFFINITY: 'soft-anti-affinity',
}

const options = [
  { label: 'Affinity (affinity policy)', value: AFFINITY_POLICIES.HARD_AFFINITY },
  { label: 'Anti-Affinity (anti-affinity policy)', value: AFFINITY_POLICIES.HARD_ANTI_AFFINITY },
  { label: 'Soft Affinity (soft affinity policy)', value: AFFINITY_POLICIES.SOFT_AFFINITY },
  {
    label: 'Soft Anti-Affinity (soft anti-affinity policy)',
    value: AFFINITY_POLICIES.SOFT_ANTI_AFFINITY,
  },
]

const policies = [
  {
    name: `${AFFINITY_POLICIES.HARD_AFFINITY}`,
    description: 'Restricts instances belonging to the server group to the same host.',
  },
  {
    name: `${AFFINITY_POLICIES.HARD_ANTI_AFFINITY}`,
    description: 'Restricts instances belonging to the server group to separate hosts.',
  },
  {
    name: `${AFFINITY_POLICIES.SOFT_AFFINITY}`,
    description: 'Attempts to restrict instances belonging to the server group to the same host.',
  },
  {
    name: `${AFFINITY_POLICIES.SOFT_ANTI_AFFINITY}`,
    description: 'Attempts to restrict instances belonging to the server group to separate hosts.',
  },
]

const PoliciesInfo = () => {
  const classes = useStyles()

  return (
    <div className={classes.tooltipContainer}>
      {policies.map((policy) => (
        <p key={policy.name}>
          <strong>{policy.name}:</strong> {policy.description}
        </p>
      ))}
    </div>
  )
}

interface Props {}

export default function PolicyPicklist({
  name = 'policy',
  label = 'Policy',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  return (
    <AsyncDropdown
      compact={compact}
      name={name}
      label={label}
      items={options}
      info={<PoliciesInfo />}
      {...rest}
    />
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  tooltipContainer: {
    padding: theme.spacing(0, 1),
  },
}))
